import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MapPin } from "lucide-react";
import { BRAND, NAV } from "../data/site";
import { useContent } from "../context/ContentContext";

export default function Footer() {
  const { content } = useContent();
  const brand = { ...BRAND, ...(content.brand || {}), instagramHandle: content.brand?.instagram_handle || BRAND.instagramHandle };
  return (
    <footer className="grain-coral border-t-2 border-ink relative overflow-hidden" data-testid="site-footer">
      <div className="relative z-10 mx-auto max-w-7xl px-5 py-16 md:px-10">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <img
              src="/brand/rmorrison-logo.png"
              alt="RMorrison — Makeup Artist & Hair Stylist"
              className="block h-24 md:h-28 w-auto select-none"
              draggable={false}
              width={3576}
              height={1456}
              data-testid="footer-logo"
            />
            <p className="eyebrow mt-4 text-ink text-[0.72rem]">Makeup Artist · Hair Stylist</p>
            <p className="mt-4 max-w-xs text-ink/90">{brand.footer_tagline || "Melbourne-based, mobile or studio. Bookings open for 2026."}</p>
          </div>
          <div>
            <h4 className="eyebrow text-ink mb-4">Wander</h4>
            <ul className="space-y-2">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-ink hover:underline underline-offset-4 decoration-2" data-testid={`footer-link-${n.label.toLowerCase().replace(/\s+/g,'-')}`}>{n.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="eyebrow text-ink mb-4">Say hi</h4>
            <ul className="space-y-3 text-ink">
              <li className="flex items-center gap-2"><Phone className="h-4 w-4" /> <a href={`tel:${(brand.phone||'').replace(/\s/g,'')}`} data-testid="footer-phone">{brand.phone}</a></li>
              <li className="flex items-center gap-2"><Mail className="h-4 w-4" /> <a href={`mailto:${brand.email}`} data-testid="footer-email">{brand.email}</a></li>
              <li className="flex items-center gap-2"><Instagram className="h-4 w-4" /> <a href={brand.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram">{brand.instagramHandle}</a></li>
              <li className="flex items-center gap-2"><MapPin className="h-4 w-4" /> {brand.location}</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 border-t-2 border-ink pt-6 flex flex-col md:flex-row justify-between gap-3 text-sm text-ink">
          <span>© {new Date().getFullYear()} R Morrison Makeup. All looks reserved.</span>
          <div className="flex gap-4 items-center">
            <Link to="/admin/login" className="text-ink/70 hover:text-ink underline underline-offset-4 decoration-2" data-testid="footer-admin-link">Admin</Link>
            <span className="eyebrow text-[0.65rem]">{brand.footer_credit || "Crafted with coral, pink & a steady hand."}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
